import { Table } from '@octano/global-ui';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationsKeys } from '../../../../locales/translations';
import { useAcademicOffers } from '../hooks/AcademicOffersLoader';
import { useColumns } from '../hooks/useColumns';
import { CeAcademicOffer } from '../types';

export function AcademicOffersTable() {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_ACADEMIC_OFFERS,
  );
  const { data, loading, updateQuery, query } = useAcademicOffers();
  const columns = useColumns();

  const handlePageChange = useCallback(
    (page: number) => {
      updateQuery({
        ...query,
        page: page + 1,
      });
    },
    [updateQuery, query],
  );

  return (
    <Table<CeAcademicOffer>
      columns={columns}
      data={data?.data ?? []}
      isLoadingResults={loading}
      pagination={{
        currentPage: (query.page ?? 1) - 1,
        itemsPerPage: query.items_per_page ?? 10,
        totalItems: data?.total ?? 0,
        totalPages: data?.total_pages ?? 0,
        onChangePage: handlePageChange,
      }}
      noResultsText={t('table.noResults')}
    />
  );
}
